export default Object.freeze({
  bySiteAndDate: [],
  byDate: [],
  byCategory: [],
  loading: true,
});
